import * as React from "react";

import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { LinkProps } from "../typings";

const Link = (props: LinkProps) => {
  const { link } = props;
  const { text, url } = link;

  if (!(text && url)) {
    return null;
  }

  return (
    <UitkLink>
      <TrackedLink moduleName="link-juice" href={url} linkName={text}>
        <UitkText inline overflow="truncate">
          {text}
        </UitkText>
      </TrackedLink>
    </UitkLink>
  );
};

export default Link;
